import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationSandbox } from '../sandbox/authentication.sandbox';

@Component({
    template: ''
})
export class LogoutComponent implements OnInit {
    constructor(
        private readonly authenticationSandbox: AuthenticationSandbox,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.authenticationSandbox.logout();
        this.router.navigate(['/']);
    }
}
